const mocks = {
  config: {
    analyticsName: "nominas",
    analyticsTypology: "abrir cuenta sueldo",
    analyticsType: "abrir cuenta sueldo",
    googleAnalyticsId: "",
    googleGTMGA4: true,
    modulo: "Acreditación de sueldo",
    cantPasos: 5,
    pasos: {
      consulta: {
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        footerText: "Footer Text",
        analyticsName: "home",
        analyticsTypology: "abrir cuenta sueldo"
      },
      oferta: {
        pasoSiguiente: "paso1",
        pasoAnterior: "consulta",
        analyticsName: "oferta",
        analyticsTypology: "abrir cuenta sueldo",
        banners: {}
      },
      renaperConfirmar: {
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        pasoSiguiente: "renaperConsultar",
        nombreSiguiente: "Confirmar",
        pasoAnterior: "consulta",
        analyticsTypology: "abrir cuenta sueldo"
      },
      renaperConsultar: {
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        pasoAnterior: "renaperConfirmar",
        analyticsTypology: "abrir cuenta sueldo"
      },
      ofertaCA: {
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        botonSiguiente: "Continuar",
        pasoSiguiente: "sucursal",
        footerText: "Footer Text",
        pasoAnterior: "consulta",
        analyticsTypology: "abrir cuenta sueldo"
      },
      ofertaCuenta: {
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        botonSiguiente: "Abrí tu cuenta en BBVA",
        analyticsTypology: "abrir cuenta sueldo"
      },
      sucursal: {
        pasoSiguiente: "graciasCA",
        pasoAnterior: "ofertaCA",
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        nombreSiguiente: "Finalizar",
        remarketing: {
          titulo: "Titulo",
          subtitulo: "Subtitulo",
          nombreSiguiente: "Confirmar"
        },
        analyticsTypology: "abrir cuenta sueldo"
      },
      paso1: {
        pasoSiguiente: "paso2",
        paso: 1,
        pasoAnterior: "oferta",
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        analyticsName: "datos personales",
        analyticsTypology: "abrir cuenta sueldo"
      },
      paso2: {
        pasoSiguiente: "paso3",
        paso: 2,
        pasoAnterior: "paso1",
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        analyticsName: "datos laborales",
        analyticsTypology: "abrir cuenta sueldo"
      },
      paso3: {
        pasoSiguiente: "paso4",
        paso: 3,
        pasoAnterior: "paso2",
        titulo: "Titulo",
        subtitulo: "Subtitulo",
        analyticsName: "actividad",
        analyticsTypology: "abrir cuenta sueldo"
      },
      paso4: {
        pasoSiguiente: "gracias",
        nombreSiguiente: "Finalizar",
        paso: 4,
        pasoAnterior: "paso3",
        titulo: "Titulo",
        analyticsName: "firma",
        analyticsTypology: "abrir cuenta sueldo",
        subtitulo: "Subtitulo"
      },
      gracias: {
        pasoAnterior: "paso4",
        footerText: "Footer Text",
        analyticsName: "gracias",
        analyticsTypology: "abrir cuenta sueldo"
      },
      thank: {
        path: "/thank",
        creado: ["parrafo creado"],
        link: ["enlace creado"]
      },
      identidad: {
        antetitulo: "Antetitulo",
        titulo: "Titulo",
        subtitulo: "Subtitulo"
      },
      graciasCA: {
        pasoAnterior: "sucursal",
        nombreSiguiente: "Finalizar",
        analyticsTypology: "abrir cuenta sueldo"
      },
      mensaje: {},
      cliente: {
        pasoAnterior: "consulta",
        footerText: "Footer Text",
        analyticsTypology: "abrir cuenta sueldo"
      },
      confirmar: {
        nombreSiguiente: "Confirmar",
        pasoSiguiente: "gracias",
        titulo: "Titulo",
        paso: 1,
        analyticsTypology: "abrir cuenta sueldo",
        subtitulo: "Subtitulo"
      },
      noCliente: {
        pasoAnterior: "consulta",
        analyticsTypology: "abrir cuenta sueldo"
      },
      clienteCA: {
        titulo: "Titulo",
        descripcion: "Descripcion",
        beneficiosTitulo: "Y te damos estos beneficios:",
        analyticsTypology: "abrir cuenta sueldo",
        beneficios: [
          {
            label: "Label",
            description: "Description"
          }
        ],
        footerText: "Footer Text"
      },
      contrato: {
        titulo: "Título",
        paso: 1
      },
      configuracion: {
        antetitulo: "Antetitulo",
        titulo: "Título",
        subtitulo: "Subtitulo",
        paso: 1
      },
      mensajeErrorSolicitudCuenta: {
        path: "/mensajeSolicitudCuenta/:mje",
        component: "views/MensajeErrorSolicitudCuenta",
        header: "Solicitud de Cuenta",
        titulo: "Esta oferta no está disponible",
        texto:
          "Ingresá a Banca Online y conocé los productos a los que podés acceder."
      },
      errorBBVAVos: {
        titulo: "titulo",
        subtitulo: "subtitulo"
      },
      celular: {
        antetitulo: "Antetitulo",
        titulo: "Título",
        subtitulo: "Subtitulo"
      },
      usuarioClave: {
        pasoSiguiente: "thankOTP",
        antetitulo: "Antetitulo",
        titulo: "Título",
        subtitulo: "Subtitulo"
      }
    },
    resumen: {
      titulo: "",
      url: "",
      boton: ""
    }
  }
};

export default mocks;
